import router from '../../router';
import axios from 'axios';
import store from '../../store';
import jwtDecode from 'jwt-decode';
import users from '../users';

export default {

    user: {
        authenticated: false
    },

    forgotPassword(context, email) {
        var options = {
            url: window.apiUrl + '/reset-password',
            method: 'POST',
            data: {email: email}
        }
        return axios.request(options).then(function(response) {
            return response;
        });
    },
    resetPassword(context, data) {
        var options = {
            url: window.apiUrl + '/reset-password',
            method: 'PATCH',
            data: data
        }
        return axios.request(options).then(function(response) {
            return response;
        });
    },
    register(context, credentials) {
        var options = {
            url: window.apiUrl + '/register',
            method: 'POST',
            data: credentials
        }
        return axios.request(options).then(function(response) {
            return response;
        });
    },
    logout(context) {
        var options = {
            url: window.apiUrl + '/logout',
            method: 'POST',
            headers: {'Authorization': 'Bearer ' + localStorage.token},

        }
        return axios.request(options).then(function(response) {
            return response;
        });
    },
    login(context, credentials) {
        var self = this;
        store.dispatch('toggle',{type:'loading', boolean: true});
        credentials.grant_type = 'password';
        var options = {
            url: window.apiUrl + '/token',
            method: 'POST',
            data: credentials,
            auth: {
                username: 'TTTO',
                password: '437f6530-1a63-4da8-b9cc-7ba1a1f48ed8'
            }
        }


        return axios.request(options).then(function(response) {
            response = response.data;
            console.log(response)
            if (response.access_token == '401') {
                return 'Unregistered';
            }
            if (response.access_token == '403') {
                return 'Disabled';
            }
            if (response.error) {
                return response;
            } else {
                if (!response.access_token) {
                    return;
                }
                //localStorage.setItem('access_key', response.response.access_key);
                localStorage.setItem('token', response.access_token);

                var decoded = jwtDecode(response.access_token);
                localStorage.setItem('user_id',decoded.id);
                localStorage.setItem('account_id',decoded.sub);
                localStorage.setItem('user_name', decoded.name);
                localStorage.setItem('legal_name', decoded.legalName);
                localStorage.setItem('uuid', decoded.uuid);
                localStorage.setItem('group', decoded.group);
                localStorage.setItem('mentor_group', decoded.mentorGroup);
                localStorage.setItem('path', decoded.path);
                localStorage.setItem('has_course_sets', decoded.hasCourseSets);
                localStorage.setItem('focus', decoded.focus);
                localStorage.setItem('terms', decoded.terms);
                localStorage.setItem('intake', decoded.intake);
                localStorage.setItem('privacyPolicyAccepted', decoded.privacyPolicyAccepted);
                localStorage.setItem('transitioned', decoded.transitioned);
                localStorage.setItem('hasLibraryAccess', decoded.hasLibraryAccess)
                localStorage.setItem('intermediateTermStartDate', decoded.intermediateTermStartDate);
                localStorage.setItem('sinRequested', decoded.sinRequested);
                localStorage.setItem('sinSubmitted', decoded.sinSubmitted);
                localStorage.setItem('allowedToChangeStatus', decoded.allowedToChangeStatus);

                // do not rely on this for access control! this is just for convenience
                // roles must be validated on the server
                localStorage.setItem('roles', JSON.stringify(decoded.scope));

                if (decoded.scope.indexOf('Mentor') > -1) {
                    localStorage.setItem('zoom_id', decoded.zoomId);
                    localStorage.setItem('venue', decoded.venue);
                }

                if (decoded.scope.indexOf('Student') > -1) {
                    router.push('/home');
                } else if (decoded.scope.indexOf('Faculty') > -1) {
                    router.push('/dashboard');
                }


                self.user.authenticated = true;

                users.getMe().then((response) => {
                    store.state.person = response.data.person;
                });

            }
            store.dispatch('toggle',{type:'loading', boolean: false});


        }).catch(function(error) {
            console.log('ERROR');
            console.log(error)
            console.log(error.message)
            store.dispatch('toggle',{type:'loading', boolean: false});
            return(error);

        });
    }
};



// WEBPACK FOOTER //
// ./src/services/auth/index.js